import { format } from 'date-fns';

export function formatarData(valor: Date | string | null | undefined): string {
    if (valor === null || valor === undefined || valor === '') return '';

    if (valor instanceof Date) {
        return format(valor, 'dd/MM/yyyy');
    }

    if (/^\d{2}\/\d{2}\/\d{4}/.test(valor)) {
        return valor.substring(0, 10);
    }

    if (/^\d{4}-\d{2}-\d{2}T/.test(valor)) {
        return format(new Date(valor), 'dd/MM/yyyy');
    }

    return valor;
}
